export const LOAD_DATA = 'loadData';
export const LOAD_EVENTS = 'loadEvents';
